export enum ConstructionProjectRole {
  OwnerConstructionManager = 'OwnerConstructionManager',
  EpcQualityManagers = 'EpcQualityManagers',
  UserFromOwnerCompany = 'UserFromOwnerCompany',
  UserFromEpcCompany = 'UserFromEpcCompany',
  UserFromSupplierCompany = 'UserFromSupplierCompany',
}
